<script setup lang="ts">
/**
 * Footer V2 — Conteúdo do accordion "Sobre nós"
 *
 * Fonte de verdade: assets/json/dynamicLicenses.json (consumido via useLicenses).
 * O texto vem com placeholders já substituídos ({{ appUrl }}, {{ companyName }},
 * {{ companyCnpj }}, {{ companyAddress }}) e contém HTML inline (<strong>, <br>).
 *
 * Tipografia (Plus Jakarta Sans 12/16, weight 400):
 *   - Conteúdo dentro de <strong> → #FFF (destaques: app url, razão social, CNPJ, endereço)
 *   - Restante do parágrafo       → rgba(255,255,255,0.50) (token White50)
 */

const { licenseText } = useLicenses();
</script>

<template>
  <div
    v-if="licenseText"
    class="footer-v2-about"
  >
    <p
      class="footer-v2-about__paragraph"
      v-html="licenseText"
    />
  </div>
</template>

<style scoped lang="scss">
.footer-v2-about {
  display: flex;
  padding: 0 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;

  /* Desktop (≥1024px) — coluna direita do footer.
     Sem padding horizontal (a coluna do shell controla largura).
     align-self: stretch mantido para o paragrafo herdar a largura. */
  @media (min-width: 1024px) {
    padding: 0;
    align-items: flex-start;
  }

  &__paragraph {
    align-self: stretch;
    color: rgba(255, 255, 255, 0.5); // White50 (texto base)
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px; /* 133.333% */
    margin: 0;

    /* Desktop: Montserrat 10/15, weight 400, color White50.
       Tamanho menor pois a coluna direita do shell é mais estreita
       e Montserrat é mais condensada que Plus Jakarta. */
    @media (min-width: 1024px) {
      font-family: 'Montserrat', sans-serif;
      font-size: 10px;
      line-height: 150%; /* 15px */
    }

    /* Destaques injetados via v-html (texto vem do JSON) */
    :deep(strong) {
      color: #fff;
      font-weight: 400; // mantém peso 400, só muda cor (não vira "bold")

      /* Desktop: #FFF Montserrat 10/15 weight 700
         (destaque real em negrito + cor branca cheia). */
      @media (min-width: 1024px) {
        font-family: 'Montserrat', sans-serif;
        font-weight: 700;
        font-size: 10px;
        line-height: 150%;
      }
    }
  }
}
</style>
